module.exports = __webpack_public_path__ + "static/media/quality.76a369ff.png";